import React from 'react'
import '../../css/modal.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'

function Modal(props) {
  const {showHeader=true}=props
  const closeModal = (e) => {
    e.stopPropagation()
    props.updateModal(false, props.type)
    props.onCloseCallback && props.onCloseCallback()
  }

  return (
    <div className="model--wrapper" style={props.modalStyle} onClick={(e) => closeModal(e)}>
      <div
        style={{ width: props?.width || '50%', height: props?.height || undefined, backgroundColor: props?.bgColor || '' }}
        className={props.modalClass ? props.modalClass : 'model--container'}
        onClick={(e) => {
          e.stopPropagation()
        }}
      >
        {
          showHeader &&
          <div className={`model--header`} style={props?.modalHeaderStyle}>
            <div>
              <div>{props.headTxt}</div>
              <div style={{ fontSize: '12px', lineHeight: 'initial' }}>{props.headText2}</div>
            </div>
            <button id={props.closeId} style={{ cursor: 'pointer' }} onClick={(e) => closeModal(e)}>
              <FontAwesomeIcon icon={faXmark} size="lg" />
            </button>
          </div>
        }
        {props.children}
      </div>
    </div>
  )
}

export default Modal
